// import { Parser } from "app-scheme-utils/lib/litb";
// import { CommonRuntime } from "utils/runtime";

/** 安卓app对协议litb://product支持欠佳， 暂时取消 */
export const GetAutoLink = (
	link: string,
	// , runtime: Partial<CommonRuntime>
) => {
	if (!link) {
		return "";
	}
	if (link.startsWith("#")) {
		return link;
	}

	// if (runtime.isInApp) {
	// 	if (!runtime.userAgent?.match(/android/gi)) {
	// 		return link;
	// 	}
	// 	return new Parser(true).convertToAppSchemeLink(link);
	// }
	return link;
};
